import {hitGoogleTagManager} from "../google_tag_manager/gtm_init";

export interface IOfferTrackingParams {
    offer_id: string;
    offer_name?: string;
    offer_slug?: string;
    make?: string;
    model?: string;
    year?: string;
    price?: string | number;
    city?: string;
    page_type?: string;
    list_name?: string;
}

const buildOfferParams = (props: IOfferTrackingParams) => {
    const {offer_id, offer_name, offer_slug, make, model, year, price, city, page_type, list_name} = props;

    return {
        offer_id: String(offer_id),
        ...(offer_name ? {offer_name} : {}),
        ...(offer_slug ? {offer_slug} : {}),
        ...(make ? {make} : {}),
        ...(model ? {model} : {}),
        ...(year ? {year} : {}),
        ...(price != null && price !== "" ? {price} : {}),
        ...(city ? {city} : {}),
        ...(page_type ? {page_type} : {}),
        ...(list_name ? {list_name} : {})
    };
};

/** Offer detail page view → GTM dataLayer → GA4 (via GTM tag). */
export const hitOfferViewEvent = (props: IOfferTrackingParams) => {
    if (!props.offer_id) {
        return;
    }

    hitGoogleTagManager({
        event: "offer_view",
        ...buildOfferParams(props)
    });
};

/** Offer card / list click → GTM dataLayer → GA4 (via GTM tag). */
export const hitOfferClickEvent = (props: IOfferTrackingParams) => {
    if (!props.offer_id) {
        return;
    }

    hitGoogleTagManager({
        event: "offer_click",
        ...buildOfferParams(props)
    });
};
